





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'SearchDialog',
})
export default class extends Vue {
  @Prop({ required: true }) private value!: string;

  @Prop({ default: () => '' }) private buttonClass!: string;

  private dialog = false;

  private searchValue = '';

  @Watch('value')
  onChangeValue(newVal: string) {
    this.searchValue = newVal;
  }

  created() {
    this.searchValue = this.value;
  }

  private search() {
    this.$emit('input', this.searchValue);
    this.dialog = false;
  }

  private reset() {
    this.$emit('input', '');
    this.dialog = false;
  }

  private close() {
    this.searchValue = this.value;
    this.dialog = false;
  }
}
